import appStoreIcon from "@/assets/AppStoreIcon.svg";

function AppStoreIconSvg({ size = 64 }: { size?: number }) {
  return <img src={appStoreIcon} width={size} height={size} alt="" />;
}

export default AppStoreIconSvg;
